import React from "react";
import { Grid } from "@mui/material";

import { formatMonetary } from "../../../../utils/formats";
import Table from "../../subcomponents/Table";

const justifyCenter = { justify: "center" };

const columnData = [
  {
    id: "codigoAvaliacao",
    name: "Avaliação",
    style: { ...justifyCenter, width: 100 },
  },
  {
    id: "codigoVeiculo",
    name: "Veículo",
    style: { ...justifyCenter, width: 100 },
  },
  { id: "placa", name: "Placa", style: { ...justifyCenter, width: 100 } },
  {
    id: "modelo",
    name: "Modelo",
    render: (value, id, entry) =>
      `${entry.linha ?? ""} ${entry.modelo ?? ""} ${entry.versao ?? ""}`,
  },
  { id: "chassi", name: "Chassi", style: { ...justifyCenter, width: 160 } },
  { id: "ano", name: "Ano", style: { ...justifyCenter, width: 100 } },
  {
    id: "valorTroca",
    name: "Valor troca",
    render: formatMonetary,
    style: { ...justifyCenter, width: 130 },
  },
  { id: "nomePessoa", name: "Proprietário", style: justifyCenter },
];

const VeiculoTrocaSection = (props) => {
  const { vehiclesOnExchange, vehiclesOnExchangeLoading } = props;

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <Table
            loading={vehiclesOnExchangeLoading}
            noDataMessage="SEM DADOS."
            entries={vehiclesOnExchange}
            columns={columnData}
            loadingRows={2}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default VeiculoTrocaSection;
